import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    /* CustomerStatuses */

    // Получение списка статусов заказчика
    async getCustomerStatuses(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/customer_statuses?${params.toString()}${sorting}`);
    },
    // Получение статуса заказчика по id
    async getCustomerStatusById(id) {
      return await this.get(`catalogs/customer_statuses/id/${id}`);
    },
    // Создание статуса заказчика
    async postCustomerStatus(data) {
      return await this.post('catalogs/customer_statuses', data);
    },
    // Изменение статуса заказчика
    async putCustomerStatus(data) {
      return await this.put(`catalogs/customer_statuses/id/${data.id}`, data);
    },
    // Получение статусов заказчика по запросу
    async getCustomerStatusesSearch(query) {
      return await this.get(`catalogs/customer_statuses/search?query=${query}`);
    },

    /* Departments */

    async getDepartments(data) {
      let params = this.makeSearchParams(data);
      return await this.get(`catalogs/departments?${params.toString()}`);
    },
    async getDepartmentById(id) {
      return await this.get(`catalogs/departments/id/${id}`);
    },
    async postDepartment(data) {
      return await this.post('catalogs/departments', data);
    },
    async putDepartment(data) {
      return await this.put(`catalogs/departments/id/${data.id}`, data);
    },
    async getDepartmentSearch(query) {
      return await this.get(`catalogs/departments/search?query=${query}`);
    },

    /* JobTitles */

    async getJobTitles(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/job_titles?${params.toString()}${sorting}`);
    },
    async getJobTitleById(id) {
      return await this.get(`catalogs/job_titles/id/${id}`);
    },
    async postJobTitle(data) {
      return await this.post('catalogs/job_titles', data);
    },
    async putJobTitle(data) {
      return await this.put(`catalogs/job_titles/id/${data.id}`, data);
    },
    async getJobTitlesSearch(query) {
      return await this.get(`catalogs/job_titles/search?query=${query}`);
    },

    /* LeadSources */

    async getLeadSources(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/lead_sources?${params.toString()}${sorting}`);
    },
    async getLeadSourceById(id) {
      return await this.get(`catalogs/lead_sources/id/${id}`);
    },
    async postLeadSource(data) {
      return await this.post('catalogs/lead_sources', data);
    },
    async putLeadSource(data) {
      return await this.put(`catalogs/lead_sources/id/${data.id}`, data);
    },
    async getLeadSourcesSearch(query) {
      return await this.get(`catalogs/lead_sources/search?query=${query}`);
    },

    /* LeadStatuses */

    async getLeadStatuses(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/lead_statuses?${params.toString()}${sorting}`);
    },
    async getLeadStatusById(id) {
      return await this.get(`catalogs/lead_statuses/id/${id}`);
    },
    async postLeadStatus(data) {
      return await this.post('catalogs/lead_statuses', data);
    },
    async putLeadStatus(data) {
      return await this.put(`catalogs/lead_statuses/id/${data.id}`, data);
    },
    async getLeadStatusesSearch(query) {
      return await this.get(`catalogs/lead_statuses/search?query=${query}`);
    },

    /* LocationCostTypes */

    // Получение списка расходов объекта
    async getLocationCostTypes(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/location_cost_types?${params.toString()}${sorting}`);
    },
    async getLocationCostTypeById(id) {
      return await this.get(`catalogs/location_cost_types/id/${id}`);
    },
    async postLocationCostType(data) {
      return await this.post(`catalogs/location_cost_types`, data);
    },
    async putLocationCostType(data) {
      return await this.put(`catalogs/location_cost_types/id/${data.id}`, data);
    },
    async getLocationCostTypesSearch(query) {
      return await this.get(`catalogs/location_cost_types/search?query=${query}`);
    },

    /* LocationStatuses */

    async getLocationStatuses(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/location_statuses?${params.toString()}${sorting}`);
    },
    async getLocationStatusById(id) {
      return await this.get(`catalogs/location_statuses/id/${id}`);
    },
    async postLocationStatus(data) {
      return await this.post(`catalogs/location_statuses`, data);
    },
    async putLocationStatus(data) {
      return await this.put(`catalogs/location_statuses/id/${data.id}`, data);
    },
    async getLocationStatusesSearch(query) {
      return await this.get(`catalogs/location_statuses/search?query=${query}`);
    },

    /* MarketingSources */

    async getMarketingSources(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/marketing_sources?${params.toString()}${sorting}`);
    },
    async getMarketingSourceById(id) {
      return await this.get(`catalogs/marketing_sources/id/${id}`);
    },
    async postMarketingSource(data) {
      return await this.post('catalogs/marketing_sources', data);
    },
    async putMarketingSource(data) {
      return await this.put(`catalogs/marketing_sources/id/${data.id}`, data);
    },

    /* ProjectStatuses */

    async getProjectStatuses(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/project_statuses?${params.toString()}${sorting}`);
    },
    async getProjectStatusById(id) {
      return await this.get(`catalogs/project_statuses/id/${id}`);
    },
    async postProjectStatus(data) {
      return await this.post(`catalogs/project_statuses`, data);
    },
    async putProjectStatus(data) {
      return await this.put(`catalogs/project_statuses/id/${data.id}`, data);
    },
    async getProjectStatusesSearch(query) {
      return await this.get(`catalogs/project_statuses/search?query=${query}`);
    },

    /* Towns */

    async getTowns(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/towns?${params.toString()}${sorting}`);
    },
    async getTownById(id) {
      return await this.get(`catalogs/towns/id/${id}`);
    },
    async postTown(data) {
      return await this.post('catalogs/towns', data);
    },
    async putTown(data) {
      return await this.put(`catalogs/towns/id/${data.id}`, data);
    },

    /* Vacancies */

    async getVacancies(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/vacancies?${params.toString()}${sorting}`);
    },
    async getVacancyById(id) {
      return await this.get(`catalogs/vacancies/id/${id}`);
    },
    async postVacancy(data) {
      return await this.post(`catalogs/vacancies`, data);
    },
    async putVacancy(data) {
      return await this.put(`catalogs/vacancies/id/${data.id}`, data);
    },
    async getVacancySearch(query) {
      return await this.get(`catalogs/vacancies/search?query=${query}`);
    },

    /* WorkerCostTypes */

    async getWorkerCostTypes(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/worker_cost_types?${params.toString()}${sorting}`);
    },
    async getWorkerCostTypeById(id) {
      return await this.get(`catalogs/worker_cost_types/id/${id}`);
    },
    async postWorkerCostType(data) {
      return await this.post(`catalogs/worker_cost_types`, data);
    },
    async putWorkerCostType(data) {
      return await this.put(`catalogs/worker_cost_types/id/${data.id}`, data);
    },
    async getWorkerCostTypesSearch(query) {
      return await this.get(`catalogs/worker_cost_types/search?query=${query}`);
    },

    /* WorkerSources */

    async getWorkerSources(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/worker_sources?${params.toString()}${sorting}`);
    },
    async getWorkerSourceById(id) {
      return await this.get(`catalogs/worker_sources/id/${id}`);
    },
    async postWorkerSource(data) {
      return await this.post('catalogs/worker_sources', data);
    },
    async putWorkerSource(data) {
      return await this.put(`catalogs/worker_sources/id/${data.id}`, data);
    },



    /* WorkerStatuses */

    async getWorkerStatuses(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/worker_statuses?${params.toString()}${sorting}`);
    },
    async getWorkerStatusById(id) {
      return await this.get(`catalogs/worker_statuses/id/${id}`);
    },
    async postWorkerStatus(data) {
      return await this.post('catalogs/worker_statuses', data);
    },
    async putWorkerStatus(data) {
      return await this.put(`catalogs/worker_statuses/id/${data.id}`, data);
    },
    async getWorkerStatusesSearch(query) {
      return await this.get(`catalogs/worker_statuses/search?query=${query}`);
    },

    /* RecruitTags */

    async getRecruitTags(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/recruit_tags?${params.toString()}${sorting}`);
    },
    async getRecruitTagById(id) {
      return await this.get(`catalogs/recruit_tags/id/${id}`);
    },
    async postRecruitTag(data) {
      return await this.post('catalogs/recruit_tags', data);
    },
    async putRecruitTag(data) {
      return await this.put(`catalogs/recruit_tags/id/${data.id}`, data);
    },
    async getRecruitTagsSearch(query) {
      return await this.get(`catalogs/recruit_tags/search?query=${query}`);
    },

    /* Citizenships */

    async getCitizenships(data) {
      let params = this.makeSearchParams(data);
      return await this.get(`catalogs/citizenships?${params.toString()}`);
    },
    async getCitizenshipById(id) {
      return await this.get(`catalogs/citizenships/id/${id}`);
    },
    async postCitizenship(data) {
      return await this.post('catalogs/citizenships', data);
    },
    async putCitizenship(data) {
      return await this.put(`catalogs/citizenships/id/${data.id}`, data);
    },
    async getCitizenshipsSearch(query) {
      return await this.get(`catalogs/citizenships/search?query=${query}`);
    },

    /* DriverLicenseCategories */

    async getDriverLicenseCategories(data) {
      let params = this.makeSearchParams(data);
      return await this.get(`catalogs/driver_license_categories?${params.toString()}`);
    },
    async getDriverLicenseCategoryById(id) {
      return await this.get(`catalogs/driver_license_categories/id/${id}`);
    },
    async postDriverLicenseCategory(data) {
      return await this.post('catalogs/driver_license_categories', data);
    },
    async putDriverLicenseCategory(data) {
      return await this.put(`catalogs/driver_license_categories/id/${data.id}`, data);
    },
    async getDriverLicenseCategoriesSearch(query) {
      return await this.get(`catalogs/driver_license_categories/search?query=${query}`);
    },

    /* EmploymentCategories */

    async getEmploymentCategories(data) {
      let params = this.makeSearchParams(data);
      return await this.get(`catalogs/employment_categories?${params.toString()}`);
    },
    async getEmploymentCategoryById(id) {
      return await this.get(`catalogs/employment_categories/id/${id}`);
    },
    async postEmploymentCategory(data) {
      return await this.post('catalogs/employment_categories', data);
    },
    async putEmploymentCategory(data) {
      return await this.put(`catalogs/employment_categories/id/${data.id}`, data);
    },
    async getEmploymentCategoriesSearch(query) {
      return await this.get(`catalogs/employment_categories/search?query=${query}`);
    },

    /* WorkerSkills */

    async getWorkerSkills(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/worker_skills?${params.toString()}${sorting}`);
    },
    async getWorkerSkillById(id) {
      return await this.get(`catalogs/worker_skills/id/${id}`);
    },
    async postWorkerSkill(data) {
      return await this.post('catalogs/worker_skills', data);
    },
    async putWorkerSkill(data) {
      return await this.put(`catalogs/worker_skills/id/${data.id}`, data);
    },
    async getWorkerSkillsSearch(query) {
      return await this.get(`catalogs/worker_skills/search?query=${query}`);
    },
    async getWorkerSkillByIds(ids) {
      return await this.get(`catalogs/worker_skills/ids?${ids}`);
    },

    /* WorkerComplaints */

    async getWorkerComplaints(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/worker_complaints?${params.toString()}${sorting}`);
    },
    async getWorkerComplaintById(id) {
      return await this.get(`catalogs/worker_complaints/id/${id}`);
    },
    async postWorkerComplaint(data) {
      return await this.post('catalogs/worker_complaints', data);
    },
    async putWorkerComplaint(data) {
      return await this.put(`catalogs/worker_complaints/id/${data.id}`, data);
    },
    async getWorkerComplaintsSearch(query) {
      return await this.get(`catalogs/worker_complaints/search?query=${query}`);
    },
    async getWorkerComplaintsByIds(ids) {
      return await this.get(`catalogs/worker_complaints/ids?${ids}`);
    },

    /* TaskWorkerStatuses */

    async getTaskWorkerStatuses(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`catalogs/ctlg_task_worker_statuses?${params.toString()}${sorting}`);
    },
    async getTaskWorkerStatusById(id) {
      return await this.get(`catalogs/ctlg_task_worker_statuses/id/${id}`);
    },
    async postTaskWorkerStatus(data) {
      return await this.post('catalogs/ctlg_task_worker_statuses', data);
    },
    async putTaskWorkerStatus(data) {
      return await this.put(`catalogs/ctlg_task_worker_statuses/id/${data.id}`, data);
    },
    async getTaskWorkerStatusesSearch(query) {
      return await this.get(`catalogs/ctlg_task_worker_statuses/search?query=${query}`);
    },
    async getTaskWorkerStatusesByIds(ids) {
      return await this.get(`catalogs/ctlg_task_worker_statuses/ids?${ids}`);
    },

    /* TaskStatuses */
    // Получение списка статусов заявки
    async getTaskStatuses() {
      return await this.get('catalogs/taskstatus');
    },

    async getTaskStatusById(id) {
      return await this.get(`catalogs/taskstatus/id/${id}`);
    },
    async getTaskStatusesSearch(query) {
      return await this.get(`catalogs/taskstatus/search?query=${query}`);
    },

    /*-----------------------*/

    /* WorkServices - Не справочник */

    async getWorkServices(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`work_services?${params.toString()}${sorting}`);
    },
    async getWorkServicesById(id) {
      return await this.get(`work_services/${id}`);
    },
    async postWorkServices(data) {
      return await this.post(`work_services`, data);
    },
    async putWorkServices(data) {
      return await this.put(`work_services/${data.id}`, data);
    },
    async getWorkServicesSearch(data) {
      let params = this.makeSearchParams(data);
      return await this.get(`work_services/search?${params.toString()}`);
    },

    /* WorkType - Не справочник */

    async getWorkTypeCatalogs(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);
      return await this.get(`work_types?${params.toString()}${sorting}`);
    },
    async getWorkTypeById(id) {
      return await this.get(`work_types/id/${id}`);
    },
    async putWorkType(data) {
      return await this.put(`work_types/${data.id}`, data);
    },
    async postWorkType(data) {
      return await this.post(`work_types`, data);
    },
    // Получение видов работ по запросу
    async getWorkTypesSearch(data) {
      let params = this.makeSearchParams(data);
      return await this.get(`work_types/search?${params.toString()}`);
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/catalogs.js